"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalManager = exports.Modal = exports["default"] = void 0;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _Modal = _interopRequireDefault(require("react-overlays/lib/Modal"));

var _events = require("../../utils/events");

var _classnames = _interopRequireDefault(require("classnames"));

var _closest = _interopRequireDefault(require("dom-helpers/query/closest"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _ModalManager = _interopRequireDefault(require("./ModalManager"));

var _OpenTransition = _interopRequireDefault(require("../../utils/OpenTransition"));

var _PortalContainer = _interopRequireDefault(require("../../PortalContainer"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/underlay/index.css");

  require("../../spectrum-css/underlay/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/underlay/index-lg.css");
} else {
  require("../../spectrum-css/underlay/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/underlay/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/underlay/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/underlay/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/underlay/multiStops/darkest.css");
var MODAL_LIFECYCLE_METHODS = ['onBackdropClick', 'onEnter', 'onEntering', 'onEntered', 'onEscapeKeyDown', 'onExit', 'onExiting', 'onExited', 'onHide', 'onShow'];
var MANAGER_SINGLETON = new _ModalManager["default"]({
  handleContainerOverflow: false
});
exports.modalManager = MANAGER_SINGLETON;
var MODAL_KEY = 1;

var ModalContainer =
/*#__PURE__*/
function () {
  function ModalContainer() {
    (0, _classCallCheck2["default"])(this, ModalContainer);
  }

  (0, _createClass2["default"])(ModalContainer, null, [{
    key: "show",
    value: function show(content, context, container) {
      var key = MODAL_KEY++; // If container is not specified, look for the provider of context

      if (!container && context) {
        container = function container() {
          return (0, _closest["default"])(_reactDom["default"].findDOMNode(context), '.react-spectrum-provider');
        };
      } else if (!container) {
        container = function container() {
          return document.querySelector('.react-spectrum-provider') || document.body;
        };
      }

      var _content$props = content.props,
          disableEscKey = _content$props.disableEscKey,
          role = _content$props.role,
          onClose = _content$props.onClose,
          onHide = _content$props.onHide,
          onExited = _content$props.onExited,
          modalProps = (0, _objectWithoutProperties2["default"])(_content$props, ["disableEscKey", "role", "onClose", "onHide", "onExited"]);
      role = role && role.indexOf('dialog') !== -1 ? 'presentation' : 'dialog'; // filter out content.props that are not modal lifecycle methods

      modalProps = MODAL_LIFECYCLE_METHODS.reduce(function (obj, key) {
        return _objectSpread({}, obj, (0, _defineProperty2["default"])({}, key, modalProps[key]));
      }, {});

      var modal = _react["default"].createElement(Modal, (0, _extends2["default"])({}, modalProps, {
        container: container,
        key: key,
        keyboard: !disableEscKey,
        role: role,
        onClose: onClose,
        onHide: (0, _events.chain)(this.hide.bind(this, key), onHide, onExited)
      }), content);

      _PortalContainer["default"].add(modal, context);

      return key;
    }
  }, {
    key: "hide",
    value: function hide(key) {
      _PortalContainer["default"].remove({
        key: key
      });
    }
  }]);
  return ModalContainer;
}();

exports["default"] = ModalContainer;

var Modal = (0, _autobindDecorator["default"])(_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      show: true
    });
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "onClose",
    value: function onClose() {
      this.setState({
        show: false
      });

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: "onEntering",
    value: function onEntering(e) {
      var _this2 = this;

      if (this.props.onEntering) {
        this.props.onEntering(e);
      }

      cancelAnimationFrame(this._autoFocusRAF);
      this._autoFocusRAF = requestAnimationFrame(function () {
        // Make sure that autoFocus actually moves focus to the Modal
        if (_this2.baseModal && _this2.baseModal.dialog) {
          var dialogNode = _reactDom["default"].findDOMNode(_this2.baseModal.dialog);

          if (dialogNode !== document.activeElement || dialogNode && !dialogNode.contains(document.activeElement)) {
            _this2.baseModal.autoFocus();
          }

          clearTimeout(_this2._autoFocusTimeout); // Safari on iOS does not move the VoiceOver cursor to the dialog
          // or announce that it has opened until it has rendered. A workaround
          // is to wait for half a second, then blur and re-focus the dialog.

          _this2._autoFocusTimeout = setTimeout(function () {
            if (document.activeElement === dialogNode) {
              dialogNode.blur();
              dialogNode.focus();
            }
          }, 500);
        }
      });
    }
  }, {
    key: "backdropMode",
    value: function backdropMode() {
      /*
       * backdropClickable (bc)
       *     bc | !bc
       *     ---|------
       *      t |static
       * if fullscreenTakeover, then always false
       */
      var _this$props$children$ = this.props.children.props,
          backdropClickable = _this$props$children$.backdropClickable,
          mode = _this$props$children$.mode;
      var backdrop = 'static';

      if (backdropClickable) {
        backdrop = true;
      }

      if (mode === 'fullscreenTakeover') {
        backdrop = false;
      }

      return backdrop;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var backdrop = this.backdropMode();
      var _this$props = this.props,
          children = _this$props.children,
          onHide = _this$props.onHide,
          modalProps = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "onHide"]); // The z-index here should match the one in Overlay

      return _react["default"].createElement(_Modal["default"], (0, _extends2["default"])({}, modalProps, {
        style: {
          zIndex: 100000,
          position: 'relative'
        },
        show: this.state.show,
        ref: function ref(baseModal) {
          return _this3.baseModal = baseModal;
        },
        onEntering: this.onEntering,
        onExited: onHide,
        onHide: this.onClose,
        backdrop: backdrop,
        manager: MANAGER_SINGLETON,
        renderBackdrop: function renderBackdrop(props) {
          return _react["default"].createElement(Underlay, props);
        },
        transition: _OpenTransition["default"],
        backdropTransition: _OpenTransition["default"]
      }), (0, _react.cloneElement)(children, {
        onClose: this.onClose
      }));
    }
  }]);
  return Modal;
}(_react["default"].Component), _temp)) || _class;

exports.Modal = Modal;

var Underlay =
/*#__PURE__*/
function (_React$Component2) {
  (0, _inherits2["default"])(Underlay, _React$Component2);

  function Underlay() {
    (0, _classCallCheck2["default"])(this, Underlay);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf3["default"])(Underlay).apply(this, arguments));
  }

  (0, _createClass2["default"])(Underlay, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          open = _this$props2.open,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, ["open"]);
      return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(props), {
        className: (0, _classnames["default"])('spectrum-Underlay', {
          'is-open': open
        })
      }));
    }
  }]);
  return Underlay;
}(_react["default"].Component);